module.exports = __webpack_public_path__ + "static/media/kache11.abf04530.png";